import React from "react";
import '../assets/css/edit.css'
import Logo from "../assets/images/logo.webp"
import { ToastContainer, toast } from 'react-toastify';
import LoginForm from "./login-form";

function Login() {
  return (
    <div className='main-wrapper'>
      <ToastContainer />
      <div className='login_wrapper'>
        <div className='left_login'>
          <a className='login_logo' href="/">
            <img src={Logo} className="img_logo" alt="logo" width="100" height="auto" />
          </a>
          <h1 className='login_header'>Welcome to the Visit Qatar.</h1>
        </div>
        <LoginForm />
      </div>
    </div>
  )
}

export default Login